import { buttonClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { indigo } from "../../themes/palette"

export const useStyles = makeStyles()(({ palette, spacing }) => ({
  topBanner: {
    padding: spacing(2, 6),
    borderRadius: "0px"
  },
  topBannerButton: {
    color: palette.common.white,
    backgroundColor: indigo[700],

    "&:hover, &:focus": {
      backgroundColor: indigo[800]
    },

    [`&.${buttonClasses.disabled}`]: {
      backgroundColor: indigo[300]
    }
  }
}))
